var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":""},on:{"click":_vm.openDialog}},[_vm._v(" Add Facebook Campaign ")])
}
var staticRenderFns = []

export { render, staticRenderFns }